import * as React from 'react';
import { InvoiceController, InvoiceControllerProps } from './Invoice.controller';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetInvoicesAndBillingQuery } from '../../../models/graphql';
import { useEffect, useMemo } from 'react';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';

export const InvoiceApollo = (): JSX.Element => {
  const navigate = useNavigate();
  const { selectedOrganization } = useSelectedOrganization();
  const { loading, data } = useGetInvoicesAndBillingQuery({
    variables: {
      organizationId: selectedOrganization?.id || ''
    }
  });
  const params = useParams();

  const invoice = useMemo(
    () => data?.organization.invoices.find(i => i.id === String(params.invoiceId)),
    [data?.organization.invoices, params.invoiceId]
  );

  // If a user tries to land on an invalid invoice
  // we direct them back to billings history
  useEffect(() => {
    if (!loading && data?.organization && !invoice) {
      navigate(`/settings/billings`);
    }
  }, [data, invoice, loading, navigate]);

  const controllerProps: InvoiceControllerProps = {
    loading,
    invoice
  };

  return <InvoiceController {...controllerProps} />;
};
